import React, { memo } from 'react';
import { NodeResizeControl } from 'reactflow';

const controlStyle = {
    background: 'transparent',
    border: 'none',
};

// Handle style: Solid block, one color
const handleStyle = {
    position: 'absolute',
    width: 90,
    height: 90,
    background: '#1890ff',
    border: 'none', // Solid block, no border
    borderRadius: 0, // Square/Block
    zIndex: 100, // Ensure on top
};

const CustomResizer = ({ isVisible, minWidth = 100, minHeight = 100, onResizeEnd }) => {
    if (!isVisible) return null;

    return (
        <>
            {/* Top Left */}
            <NodeResizeControl
                style={{ ...handleStyle, top: -45, left: -45 }}
                minWidth={minWidth}
                minHeight={minHeight}
                variant="resize"
                position="top-left"
                onResizeEnd={onResizeEnd}
            />

            {/* Top Right */}
            <NodeResizeControl
                style={{ ...handleStyle, top: -45, right: -45 }}
                minWidth={minWidth}
                minHeight={minHeight}
                variant="resize"
                position="top-right"
                onResizeEnd={onResizeEnd}
            />

            {/* Bottom Left */}
            <NodeResizeControl
                style={{ ...handleStyle, bottom: -45, left: -45 }}
                minWidth={minWidth}
                minHeight={minHeight}
                variant="resize"
                position="bottom-left"
                onResizeEnd={onResizeEnd}
            />

            {/* Bottom Right */}
            <NodeResizeControl
                style={{ ...handleStyle, bottom: -45, right: -45 }}
                minWidth={minWidth}
                minHeight={minHeight}
                variant="resize"
                position="bottom-right"
                onResizeEnd={onResizeEnd}
            />

            {/* Border Outline */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: '2px solid #1890ff',
                pointerEvents: 'none',
                zIndex: 90
            }} />
        </>
    );
};

export default memo(CustomResizer);
